// tslint:disable
/**
 * Point of Sale
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ProblemDetails } from '../models';
import { PurchaseProductRequest } from '../models';
import { PurchaseResult } from '../models';
/**
 * PurchaseApi - axios parameter creator
 * @export
 */
export const PurchaseApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {PurchaseProductRequest} [purchaseProductRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasePost(purchaseProductRequest?: PurchaseProductRequest, options: any = {}): RequestArgs {
      const localVarPath = `/purchase`;
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof purchaseProductRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(purchaseProductRequest !== undefined ? purchaseProductRequest : {})
        : purchaseProductRequest || '';

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PurchaseApi - functional programming interface
 * @export
 */
export const PurchaseApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {PurchaseProductRequest} [purchaseProductRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasePost(
      purchaseProductRequest?: PurchaseProductRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseResult> {
      const localVarAxiosArgs = PurchaseApiAxiosParamCreator(configuration).purchasePost(
        purchaseProductRequest,
        options
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * PurchaseApi - factory interface
 * @export
 */
export const PurchaseApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {PurchaseProductRequest} [purchaseProductRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchasePost(
      purchaseProductRequest?: PurchaseProductRequest,
      options?: any
    ): AxiosPromise<PurchaseResult> {
      return PurchaseApiFp(configuration).purchasePost(purchaseProductRequest, options)(
        axios,
        basePath
      );
    },
  };
};

/**
 * PurchaseApi - object-oriented interface
 * @export
 * @class PurchaseApi
 * @extends {BaseAPI}
 */
export class PurchaseApi extends BaseAPI {
  /**
   *
   * @param {PurchaseProductRequest} [purchaseProductRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PurchaseApi
   */
  public purchasePost(purchaseProductRequest?: PurchaseProductRequest, options?: any) {
    return PurchaseApiFp(this.configuration).purchasePost(purchaseProductRequest, options)(
      this.axios,
      this.basePath
    );
  }
}
